<style scoped>
.explain {
  background: #fff;
  border-radius: 4px;
  text-align: left;
  margin: 20px 14px;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.explain-header {
  padding: 20px 0;
  overflow: hidden;
  /* border-bottom: 1px solid #ccc; */
}
.explain-header b{
  font-size: 20px;
  font-weight: 400;
  color: #323233;
}
.explain-contain {
  padding: 20px 20px 30px 60px;
}
.explain-title {
  /* width: 130px; */
  display: inline-block;
}
.cost-img {
  width: 300px;
}
.state-approval {
  font-size: 12px;
  display: inline-block;
  padding: 3px 10px 4px 10px;
  border-radius: 10px;
  margin-left: 20px;
}

.now-state {
  width: 112px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
}
.state-now-pass {
  color: #fff;
  background: #4fa1a4;
}
.state-now-unpass {
  color: red;
  border: 1px solid red;
}
.state-now-revoke{
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.state-back {
  width: 84px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #C8C9CD;
}
.approval {
  margin: 10px 10px 60px 10px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
  padding: 30px 60px 60px 60px;
}
.approval-list {
  display: flex;
}
.list-left {
  margin-right: 10px;
}
.left-box {
  width: 55px;
  height: 55px;
  color: #fff;
  line-height: 51px;
  background: #999;
  text-align: center;
  border-radius: 4px;
  margin: 0px 10px;
}
.left-line {
  width: 0.5px;
  height: 40px;
  background: #999;
  margin-left: 37px;
}
.approval-list:last-child .list-left .left-line {
  display: none;
}
.approval-detail /deep/.el-dialog__body {
  padding: 10px 20px;
}
.state-now {
  color: #e59940;
  background: rgba(255, 242, 224, 0.23);
  /* border: 1px solid #e59940; */
  /* border: 1px solid #C8C9CD; */
}
.state-pass{
  color: #4fa1a4;
  background: rgba(79,161,164,.1);
  /* border: 1px solid #4fa1a4; */
}
.state-reject{
  color: rgb(255, 85, 85);
  background: rgba(255, 85, 85, 0.07);
  /* border: 1px solid rgb(255, 85, 85); */
}
.state-undo{
  color: rgb(197, 202, 213);
  background: #fff;
  border: 1px solid rgb(197, 202, 213);
}
.title-pass{
  background: #4fa1a4!important;
}
.title-reject{
  background: red!important;
}
.explain-item{
  line-height: 40px;
  display: flex;
}
.explain-title{
  flex-shrink: 0;
}
.explain-content{
  display: inline-block;
  /* line-height: 30px; */
}
.link-active{
  color: blue;
  text-decoration:underline ;
  cursor: pointer;
}
.doc-img{
  width: 80px;
  height: 80px;
  margin-right: 24px;
  cursor: pointer;
}
.doc-img img{
  width: 80px;
  height: 80px;
}
</style>
<template>
  <div class="approval-detail" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="explain">
      <div class="explain-header">
        <b class="font-S20">{{flowName}}</b>
        <span class="state-approval state-now" v-if="onlineDetail.approveState == 'N' || onlineDetail.approveState == 'A'">审批中</span>
        <span class="state-approval state-pass" v-if="onlineDetail.approveState == 'Y' ">已通过</span>
        <span class="state-approval state-reject" v-if="onlineDetail.approveState == 'R' ">已驳回</span>
        <span class="state-approval state-undo" v-if="onlineDetail.approveState == 'C' ">已撤销</span>
        <span :class="onlineDetail.approveState == 'Y'? 'state-back fr':'state-back fr ml30'" @click="$router.go(-1)">返回</span>
        <span class=" state-back fr mr15 ml30" v-if="onlineDetail.approveState == 'Y'" @click="toPrinting()">打印</span>
        <span class="now-state state-now-unpass fr mr15" v-if="(approveStaffGuid == staffGuid)&&(onlineDetail.approveState == 'N' || onlineDetail.approveState == 'A')" @click="toReject()">驳回</span>
        <span class="now-state state-now-pass fr mr15" v-if="(approveStaffGuid == staffGuid)&&(onlineDetail.approveState == 'N' || onlineDetail.approveState == 'A')" @click="toPass()">通过</span>
        <!-- <span class="now-state state-now-pass fr mr15" v-if="(onlineDetail.approveState == 'R' && onlineDetail.staffGuid == staffGuid)" @click="reSubmit()">重新提交</span>
        <span class="now-state state-now-revoke fr mr15" v-if="(onlineDetail.approveState == 'N' && onlineDetail.staffGuid == staffGuid)" @click="toRevoke()">撤销</span>
        <span class="now-state state-now-pass fr mr15" v-if="onlineDetail.approveState == 'Y' &&
          onlineDetail.staffGuid == staffGuid && onlineDetail.meetingUrl == null"  @click="toResult()">调整会议时间</span> -->
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">申请信息</span>
      </div>
      <div class="explain-contain">
        <div class="explain-item"><span class="explain-title">申请人：</span> <span class="explain-content">{{onlineDetail.staffName}}</span></div>
        <div class="explain-item"><span class="explain-title">提交时间：</span> <span class="explain-content">{{onlineDetail.createTime | getTime}}</span></div>
        <div class="explain-item"><span class="explain-title">所在部门：</span> <span class="explain-content">{{ onlineDetail.organisationName }}</span></div>
        <div class="explain-item">
          <span class="explain-title">所属公司：</span>
          <span class="explain-content">{{ tenantName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">会议主题：</span> <span class="explain-content">{{ onlineDetail.meetingSubject }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">会议类型：</span> <span class="explain-content">{{ onlineDetail.meetingType | meetingType}}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">开始时间：</span> <span class="explain-content">{{ onlineDetail.startTime | getTime}}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">结束时间：</span> <span class="explain-content">{{ onlineDetail.endTime | getTime}}</span>
        </div>
        <!-- <div class="explain-item">
          <span class="explain-title">关联费用申请流程</span> <span class="explain-content link-active" @click="toLink()">{{ onlineDetail.meetingCostApply ? onlineDetail.meetingCostApply.name : ''}}-学术会议费用申请</span>
        </div> -->
        <div class="explain-item"><span class="explain-title">参会人数：</span> <span class="explain-content">{{ onlineDetail.peopleNum }} 人</span></div>
        <div class="explain-item"><span class="explain-title">安全级别：</span> <span class="explain-content">{{ onlineDetail.safeLevel | safeLevel }} </span></div>
        <div class="explain-item">
          <span class="explain-title">会议方案：</span>
          <span class="explain-content"  v-if="onlineDetail.meetingPlan">{{caCodeToDesc(onlineDetail.meetingPlan)}} </span>
          <span class="explain-content"  v-else>-</span>
        </div>
        <div class="explain-item"><span class="explain-title">会议议程：</span> <span class="explain-content" v-html="changeEnter(onlineDetail.meetingAgenda)"></span></div>
        <div class="explain-item"><span class="explain-title">会议目的：</span> <span class="explain-content">{{ onlineDetail.meetingPrupose }}</span></div>
        <div class="explain-item"><span class="explain-title">预期效果：</span> <span class="explain-content">{{ onlineDetail.desiredResult }}</span></div>
        <div class="explain-item"><span class="explain-title">讲者介绍：</span> <span class="explain-content">{{ onlineDetail.speakerIntroduction }}</span></div>
        <div class="explain-item"><span class="explain-title">会议负责人：</span> <span class="explain-content">{{ onlineDetail.leader }}</span></div>
        <div class="explain-item"><span class="explain-title">负责人电话：</span> <span class="explain-content">{{ onlineDetail.leaderMobileNo }}</span></div>
      </div>
      <div class="cost-title-list mb25">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">流程审批</span>
      </div>
      <flowList :approvalList="approvalList" :carbonName="carbonName" :approveState="onlineDetail.approveState"></flowList>
    </div>
    <div class="h20"></div>
    <el-dialog title="驳回流程" :visible.sync="dialogVisible" width="30%" top="15%" >
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    
    <printDialog :printType="2" :showPrintDialog.sync='showPrint' :printData="onlineDetail" :approvalList="approvalList" @closePrint="closePrint"></printDialog>
  
  </div>
</template>
<script>
import flowList from '@/components/flowList.vue'
import printDialog from '@/components/printDialog.vue';
export default {
  components:{
    flowList,
    printDialog
  },
  data() {
    return {
      dialogVisible: false,
      onlineDetail:{},
      approveSuggest:'',
      flowName:'线上会议执行2',
      carbonName:'',
      approvalList:[],
      approveStaffGuid:'',
      staffGuid:"",
      imgList:[],
      url:'',
      flowType:'00002',
      fullscreenLoading:false,
      tenantName:'',
      currentStaffGuid:'',      
      showPrint:false //打印
    };
  },
  created(){
    let userinfo = JSON.parse(localStorage.userInfo);
    this.staffGuid  = userinfo.staffGuid
    this.approveStaffGuid = this.$route.query.approveStaffGuid;
    this.tenantName = this.$route.query.tenantName;
    this.getMeetingCaList();
  },
  methods: {
    //打印
    closePrint(){
      this.showPrint = false
    },
     getMeetingCaList(){
        var self = this;
        var page = {
          pageIndex: 1,
          pageSize: -1,
          isOpen: '-1',
        }
        self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/get-list`, page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.meetingPlanList =  res.data.data.records;
          self.getData();
          self.getApprovalList();
        } else { 
          self.$message.error(res.data.msg);
        }
      });
      },
    caCodeToDesc(listStr) {
      if (listStr != '') {
         listStr = listStr.replace(/"/g,'').replace(/[\\]/g,'').replace(/\[/g,'').replace(/\]/g,'').replace(/\,/g,'；');
         return listStr;
      }
    },
    changeEnter(content){
      if(content == '' || content == null){
        return '无';
      }else{
        content = content.replace(/\n/g,"</br>");
        return content;
      }
    },
    getData() {
      let self = this;
      self.fullscreenLoading = true
      self.api.postCan(
        `/${serverConfig.msSalesPerformService}/flow/data/get-online-meeting-detail?guid=` +
          self.$route.query.bizGuid
      ).then( (res)=> {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false
          self.onlineDetail = res.data.data;
        //   self.imgList = [];
        //   if(res.data.data.applyForm !== null){
        //     let applyForm = JSON.parse(res.data.data.applyForm);
        //     applyForm.forEach(item=>{
        //       self.imgList.push(item.path)
        //     })
        //     console.log(self.imgList);
        //   }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取流程列表
    getApprovalList(){
      let self = this;
      self.api.postCan(`/${serverConfig.msSalesPerformService}/approve/data/get-flow-running-node?flowType=00002&guid=`+self.$route.query.guid).then((res)=> {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.approvalList = res.data.data;
          self.approvalList.sort(
            (n1,n2)=>{
              return n1.orderNum-n2.orderNum;
          });
          self.carbonName = JSON.parse(res.data.data[0].ccGuids)[0].name;
        } else{
          self.$message.error(res.data.msg);
        }
      }); 
    },
    //跳转到关联
    toLink(){
      let self = this;
      self.$router.push({
        path:'/approvalDetail',
        query:{
          productGuid:this.$route.query.productGuid,
          guid:self.onlineDetail.meetingCostApplyGuid,
          approveStaffGuid:self.$route.query.approveStaffGuid,
          productGuid:this.$route.query.productGuid
        }
      })
    },
    //打印
    toPrinting(){
      this.showPrint = true
      // let self = this;
      // self.$router.push({
      //   path:'/reportProcess',
      //   query:{
      //     guid:self.$route.query.guid,
      //     flowType:'00002'
      //   }
      // })
    },
    //通过
    toPass(){
      let self = this;
      self.$confirm('操作后不可恢复，确定审批通过吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let query = {
          guid: self.$route.query.guid,
          flowType: self.flowType,
          approveStaffGuid:self.staffGuid
        };
        self.fullscreenLoading = true
        self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/allow-flow`, query).then(
          (res) =>{
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false
            self.$message.success("审批通过！");
            // self.getData();
            // self.getApprovalList();
            sessionStorage.refresh = 1;
            self.$router.push({
                path: "/processList"
              });
          }else{
            self.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消审批！'
        });          
      });  
    },
    toReject(){
      let self = this;
      self.dialogVisible = true;
    },
    //驳回
    toRejectSubmit(){
      let self = this;
      if(self.approveSuggest == ''){
        self.$message.error("请填写驳回理由！");
        return;
      }
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest:self.approveSuggest,
        approveStaffGuid:self.staffGuid
      };
      self.fullscreenLoading = true
      self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/backup-flow`, query).then(
        (res)=> {
          if ((res.data.code == serverConfig.REQUIRE_SUCCESS_CODE)) {
            self.fullscreenLoading = false
            self.$message.success("驳回成功！");
            // self.getData();
            // self.getApprovalList();
            sessionStorage.refresh = 1;
            self.dialogVisible = false;
            self.$router.go(-1);
          }else{
            self.$message.error(res.data.msg);
          }
        }
      );
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.$route.query.guid,
            flowType: self.flowType,
            approveStaffGuid:self.staffGuid
          };
          self.fullscreenLoading = true
          self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false
              self.$message.success('撤销成功！');
              // self.getData();
              // self.getApprovalList();
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/onlineApprove',
        query: {
          guid: this.$route.query.guid,
        },
      });
    },
    //调整会议时间
    toResult() {
      let currentTime = new Date().getTime();
      let time = new Date(this.onlineDetail.startTime).getTime() -
        currentTime;
      //大于24才可以调整时间
      if (time > 24 * 60 * 60 * 1000) {
        this.$router.push({
          path: "/onlineApprove",
          query: {
            meetingGuid: this.$route.query.bizGuid,
            approveStaffGuid:this.$route.query.approveStaffGuid
          },
        });
      } else {
        this.$message.warning("无法调整，只能提前24小时修改！");
      }
    },
  },
};
</script>
